import React, { useState } from 'react';
import '../assets/css/main.css';
import NavBar from "../components/navbar";
import Footer from "../components/footer";
import WorksSummaryTile from "../components/works/WorksSummaryTile";
import WorksDetail from "../components/works/WorksDetail";

function Works() {

    let [workDetail, setWorkDetail] = useState<number | null>(null);

    const handleTileClick = (id: number | null) => {
    setWorkDetail(id); // sets which work detail to show
    };

    return (
        <>
            <NavBar/>
            <main className="main">
                <section id="services" className="services section">
                    <div className="container section-title" data-aos="fade-up">
                        <h2>Works</h2>
                    </div>
                    {!workDetail && (
                        <div className="container">
                            <div className="row gy-4 justify-content-center">
                                <WorksSummaryTile
                                    id={1}
                                    title={"Premier Concerto in A Minor"}
                                    description={"Violin Concerto in the Baroque tradition for String Orchestra and Cembalo"}
                                    onClick={() => handleTileClick(1)}/>
                            </div>
                        </div>
                    )}
                  {workDetail && (
                    <WorksDetail id={workDetail} onTileClick={handleTileClick} />
                  )}
                </section>
            </main>
            <Footer/>
        </>
    )
}

export default Works;